import React from "react";
import { Spinner } from "react-bootstrap";

interface LoadingSpinnerProps {
    message: string
}

export const LoadingSpinner = ({ message }: LoadingSpinnerProps) => {
    return (
        <div className="align-items-center d-flex">
            <span className="mr-2"><Spinner animation="border" variant="secondary" /></span> {message}
        </div>
    );
}

